/**
 * 清理可能残留在 document.body 上的 Element Plus 全屏 Loading（ElLoading.service）。
 * 异常跳转或未关闭 Loading 时，遮罩与 body 上的 lock 类会挡住整页交互（含登录框输入）。
 */
export function resetBodyElLoadingArtifacts() {
  if (typeof document === 'undefined') return
  try {
    const maskNodes = [
      ...document.querySelectorAll('body > .el-loading-mask'),
      ...document.querySelectorAll('body > .el-loading__mask')
    ]
    maskNodes.forEach((el) => el.remove())
    document.body.classList.remove(
      'el-loading-parent--relative',
      'el-loading-parent--hidden',
      'el-popup-parent--hidden'
    )
    document.documentElement.classList.remove('el-popup-parent--hidden')
    document.body.removeAttribute('loading-number')
    document.body.style.removeProperty('overflow')
    document.body.style.removeProperty('position')
    document.body.style.removeProperty('width')
    document.documentElement.style.removeProperty('overflow')
  } catch (_) {
    /* ignore */
  }
}

/** 移动工作台：滚动只发生在 .m-main，避免 body 被弹窗/Loading 锁死后整页无法滑动 */
export const MOBILE_SHELL_HTML_CLASS = 'erp-mobile-shell-active'

export function enableMobileShellScrollLock() {
  if (typeof document === 'undefined') return
  resetBodyElLoadingArtifacts()
  document.documentElement.classList.add(MOBILE_SHELL_HTML_CLASS)
  // 避免桌面壳写入的 --erp-shell-w 残留，导致手机端外壳比可视区更宽
  try {
    document.documentElement.style.setProperty('--erp-shell-w', '100%')
  } catch (_) {
    /* ignore */
  }
}

export function disableMobileShellScrollLock() {
  if (typeof document === 'undefined') return
  document.documentElement.classList.remove(MOBILE_SHELL_HTML_CLASS)
  resetBodyElLoadingArtifacts()
}
